;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/checkout/:merchant_username\",\"regex\":\"^/checkout/([^/]+)$\",\"paramNames\":[\"merchant_username\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/business-selection\"},{\"path\":\"/dashboard\"},{\"path\":\"/login\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.4";globalThis["_sentryRewritesTunnelPath"] = "/mataxnyh";import { globalHandlersIntegration, replayIntegration } from '@sentry/browser'
import * as Sentry from '@sentry/nextjs'

import {
  beforeSend,
  getReplaySessionSampleRate,
  getSentryRelease,
  getTracesSampleRate,
  SENTRY_IGNORE_ERRORS,
} from './src/lib/error/sentry.shared'

function getIntegrations() {
  const integrations = [
    ...Sentry.getDefaultIntegrations({}).filter(integration => {
      // Filter out GlobalHandlers integration to disable auto global handlers
      return integration.name !== 'GlobalHandlers'
    }),

    globalHandlersIntegration({
      onerror: true,
      onunhandledrejection: false, // Disable automatic unhandled rejection handling
    }),

    replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ]

  return integrations
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  sendDefaultPii: false,
  tracesSampleRate: getTracesSampleRate(),
  replaysSessionSampleRate: getReplaySessionSampleRate(),
  replaysOnErrorSampleRate: 1.0,
  release: getSentryRelease(),
  debug: false,
  maxBreadcrumbs: 50,
  beforeSend,
  integrations: getIntegrations(),

  ignoreErrors: SENTRY_IGNORE_ERRORS,
})

// eslint-disable-next-line import/namespace -- exported from the @sentry/nextjs client bundle at runtime
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
